import { CARGO_SETVC,
  CARGO_SETCC,
  CARGO_SETPC,
  CARGO_SETTC } from '@/store/mutations-type'
const common = require('@/lib/common')

const state = {
  vesselOptCache: common.getStoreData('vesselopt') || [],
  countryOptCache: common.getStoreData('countryopt') || [],
  portOptCache: common.getStoreData('portopt') || [],
  terminalOptCache: common.getStoreData('terminalopt') || [],
}

const mutations = {
  [CARGO_SETVC](state, vesselInfo) {
    let vo = common.getStoreData('vesselopt') || [];
    if(vo.length > 4){
      vo.pop()
      vo.unshift(vesselInfo)
    }else{
      vo.unshift(vesselInfo)
    }
    state.vesselOptCache = vo;
    common.setStoreData('vesselopt', vo)
  },
  [CARGO_SETCC](state, countryInfo) {
    let co = common.getStoreData('countryopt') || [];
    if(co.length > 4){
      co.pop()
      co.unshift(countryInfo)
    }else{
      co.unshift(countryInfo)
    }
    state.countryOptCache = co;
    common.setStoreData('countryopt', co)
  },
  [CARGO_SETPC](state, portInfo) {
    let po = common.getStoreData('portopt') || [];
    if(po.length > 4){
      po.pop()
      po.unshift(portInfo)
    }else{
      po.unshift(portInfo)
    }
    state.portOptCache = po;
    common.setStoreData('portopt', po)
  },
  [CARGO_SETTC](state, terminalInfo) {
    let to = common.getStoreData('terminalopt') || [];
    if(to.length > 4){
      to.pop()
      to.unshift(terminalInfo)
    }else{
      to.unshift(terminalInfo)
    }
    state.terminalOptCache = to;
    common.setStoreData('terminalopt', to)
  },
}

const actions = {
  async setVC({ state, commit }, vesselInfo) {
    commit(CARGO_SETVC, vesselInfo)
  },
  async setCC({ state, commit }, countryInfo) {
    commit(CARGO_SETCC, countryInfo)
  },
  async setPC({ state, commit }, portInfo) {
    commit(CARGO_SETPC, portInfo)
  },
  async setTC({ state, commit }, terminalInfo) {
    commit(CARGO_SETTC, terminalInfo)
  },
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/cargoflow.js